import { apiRequest, type QueryValue } from './client';
import type { DashboardFilters, DashboardSummary, WorkItemView } from './types';

export const dashboard = {
  summary: (organizationId: string, filters: DashboardFilters = {}) =>
    apiRequest<DashboardSummary>('/api/dashboard', {
      organizationId,
      query: filters as Record<string, QueryValue>,
    }),

  workItems: (organizationId: string, filters: DashboardFilters = {}) =>
    apiRequest<WorkItemView[]>('/api/dashboard/work-items', {
      organizationId,
      query: filters as Record<string, QueryValue>,
    }),
};
